import axios from "axios";

class FlipThisRecipe {
  constructor(
    flipButton,
    heroContainer,
    nextHeroContainer,
    flipThisRecipeLink
  ) {
    this.flipButton = flipButton;
    this.heroContainer = heroContainer;
    this.nextHeroContainer = nextHeroContainer;
    this.flipThisRecipeLink = flipThisRecipeLink;

    this.initEventListeners();
    this.fetchNextRecipeData();
  }

  initEventListeners() {
    this.flipButton.addEventListener(
      "click",
      this.handleFlipButtonClick.bind(this)
    );
  }

  async fetchNextRecipeData() {
    try {
      const response = await axios.get(this.flipThisRecipeLink);
      const parser = new DOMParser();
      this.htmlDoc = parser.parseFromString(response.data, "text/html");

      const heroImage = this.htmlDoc.querySelector(".recipe-image");
      const title = this.htmlDoc.querySelector(".hero-details h1").textContent;
      const description = this.htmlDoc.querySelector(
        ".hero-details .description"
      ).textContent;
      const nextFlipThisRecipeLink = this.htmlDoc.querySelector(
        "#flip-this-recipe-link"
      ).href;

      this.nextRecipeData = {
        heroImage: heroImage ? heroImage.src : "",
        title: title,
        description: description,
        nextFlipThisRecipeLink: nextFlipThisRecipeLink,
      };

      // console.log("Fetched next recipe data:", this.nextRecipeData);
    } catch (error) {
      // console.error("Error fetching next recipe data:", error);
      // Handle the error appropriately (e.g., show an error message to the user)
    }
  }

  async handleFlipButtonClick(event) {
    event.preventDefault();
    try {
      await this.flipHero();
    } catch (error) {
      console.error("Error during flip animation:", error);
      // Handle the error appropriately (e.g., show an error message to the user)
    }
  }

  async flipHero() {
    sessionStorage.setItem("scrollPosition", window.scrollY);

    this.heroContainer.classList.remove("flip-out", "flip-in");
    this.nextHeroContainer.classList.remove("flip-out", "flip-in");

    this.heroContainer.classList.add("flip-out");

    setTimeout(async () => {
      this.updateHeroSection();
      // window.history.pushState(
      //   { urlPath: this.flipThisRecipeLink },
      //   "",
      //   this.flipThisRecipeLink
      // );

      window.location.href = this.flipThisRecipeLink;
      // this works better, figure out scroll

      // Include the scroll position in the URL as a query parameter , might be the logic, but doesnt work yet.
      // const urlWithScrollPosition = `${this.nextRecipeData.nextFlipThisRecipeLink}?scrollPosition=${scrollPosition}`;
      // window.location.href = urlWithScrollPosition;
      setTimeout(async () => {
        this.heroContainer.classList.remove("flip-out");
        this.heroContainer.classList.add("flip-in");

        setTimeout(async () => {
          await this.updateRestOfContent();
          // window.location.href = this.flipThisRecipeLink;

          // sessionStorage.removeItem("scrollPosition");
          //moved to main for retaining position after reload
          // Update the flip button link
          this.flipThisRecipeLink = this.nextRecipeData.nextFlipThisRecipeLink;

          // Fetch the data for the next recipe
          await this.fetchNextRecipeData();

          // Reinitialize the event listener for the flip button
          this.initEventListeners();
        }, 1000);
      }, 1000);
    }, 1000);
  }

  updateHeroSection() {
    this.nextHeroContainer.innerHTML = `
      <div class="hero-row">
        <img class="recipe-image" src="${this.nextRecipeData.heroImage}" alt="${this.nextRecipeData.title}">
        <div class="hero-details">
          <h1 class="headline">${this.nextRecipeData.title}</h1>
          <p class="description">${this.nextRecipeData.description}</p>
        </div>
      </div>
    `;
    this.heroContainer.innerHTML = this.nextHeroContainer.innerHTML;
  }

  async updateRestOfContent() {
    try {
      const restOfContent = this.htmlDoc.body.innerHTML;
      document.body.innerHTML = restOfContent;
      this.initEventListeners();
      // await this.fetchNextRecipeData();
    } catch (error) {
      console.error("Error updating rest of content:", error);
      // Handle the error appropriately (e.g., show an error message to the user)
    }
  }
}

export default FlipThisRecipe;
